import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Calendar,
  Clock,
  Edit,
  MoreVertical,
  Users,
  Eye,
  XCircle,
  FileText,
  Briefcase,
  Search,
  SearchCheck,
  SearchIcon,
} from "lucide-react";
import usePaginationStore from "@/hooks/stores/usePaginationStore";
import Pagination from "../Common/Pagination";

const CampaignTable = ({
  campaigns,
  handleEdit,
  handleDelete,
  handleStatusChange,
  setActiveTab,
  setCampaignId,
  setActiveMenu,
  activeMenu,
  onVacanciesClick,
  handleSearchChange,
  searchTerm = "",
  noCampaignMessage = "No campaigns created yet",
  serverPagination,
  onPageChange,
  onPerPageChange,
}) => {
  const navigate = useNavigate();
  const { getPerPage, setPerPage } = usePaginationStore();
  const [searchQuery, setSearchQuery] = useState(searchTerm);
  const [statusMenu, setStatusMenu] = useState(null);

  // console.log("campaigns-------------------", campaigns)
  const currentCampaigns = campaigns;

  const searchLower = searchQuery.toLowerCase();

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (handleSearchChange) {
      handleSearchChange(value);
    }
  };
  const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":");
    return `${hours}:${minutes}`;
  };

  // If there are no campaigns, return null to hide the table and search bar
  // if (campaigns.length === 0) {
  //   return (
  //     <div className="flex justify-center items-center h-24">
  //       <p className="text-muted-foreground text-lg">{noCampaignMessage}</p>
  //     </div>
  //   );
  // }

  return (
    <>
      {campaigns.length > 0 ? (
        <div className="bg-card shadow rounded-lg">
          <table className="min-w-full divide-y divide-border">
            <thead className="bg-muted border-b border-border rounded-t-lg">
              <tr>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider rounded-tl-lg">
                  Campaign Details
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Timeline
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Vacancies
                </th>
                <th className="px-6 py-5 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                  Recruiters
                </th>
                <th className="px-6 py-5 text-center text-xs font-semibold text-muted-foreground rounded-tr-lg uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {currentCampaigns.map((campaign) => (
                <tr key={campaign.id} className="hover:bg-muted">
                  <td className="px-6 py-4">
                    <div className="flex flex-col">
                      <div
                        onClick={() => onVacanciesClick(campaign)}
                        className="text-md font-medium text-foreground mb-1 cursor-pointer hover:text-indigo-600 transition-colors"
                      >
                        {campaign.title}
                        <div className="text-xs text-muted-foreground">
                          {campaign?.company?.name}
                        </div>
                      </div>
                      <div className="text-xs text-muted-foreground hidden">
                        {campaign.email}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 text-muted-foreground mr-2" />
                      <span className="text-sm text-foreground">
                        {new Date(campaign.start_date).toLocaleDateString()} -{" "}
                        {new Date(campaign.end_date).toLocaleDateString()}
                      </span>
                    </div>
                    {campaign.start_time && campaign.end_time && (
                      <div className="flex items-center mt-1">
                        <Clock className="h-4 w-4 text-muted-foreground mr-2" />
                        <span className="text-sm text-muted-foreground">
                          {formatTime(campaign.start_time)} -{" "}
                          {formatTime(campaign.end_time)}
                        </span>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center space-x-2">
                      <div className="relative">
                        {campaign.status == 2 ? (
                          <span
                            className={`px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800`}
                          >
                            Archived
                          </span>
                        ) : (
                          <div className="relative inline-block text-left">
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                campaign.status == 1
                                  ? "bg-green-100 text-green-800 cursor-pointer"
                                  : campaign.status == 0
                                    ? "bg-yellow-100 text-yellow-800 cursor-pointer"
                                    : "bg-red-100 text-red-800 cursor-pointer"
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (campaign.status != 2) {
                                  console.log(statusMenu, campaign.id);
                                  setStatusMenu(
                                    statusMenu == campaign.id
                                      ? null
                                      : campaign.id,
                                  );
                                }
                              }}
                            >
                              {campaign.status == 1
                                ? "Published"
                                : campaign.status == 0
                                  ? "Draft"
                                  : "Archived"}
                            </span>
                            {statusMenu == campaign.id && (
                              <>
                                <div
                                  className="fixed inset-0 z-[99]"
                                  onClick={() => setStatusMenu(null)}
                                ></div>
                                <div className="absolute transform translate-x-[-30%] mt-2 w-56 origin-top-right bg-card rounded-lg shadow-lg ring-1 ring-border z-[100] divide-y divide-border">
                                  {campaign.status == 1 && (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(campaign.id, 0);
                                        setStatusMenu(null);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                    >
                                      <FileText className="h-4 w-4 mr-3 text-muted-foreground" />
                                      Mark as Draft
                                    </button>
                                  )}
                                  {[0, 1].includes(
                                    parseInt(campaign.status),
                                  ) ? (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(campaign.id, 2);
                                        setStatusMenu(null);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                    >
                                      <XCircle className="h-4 w-4 mr-3 text-red-500" />
                                      Archive
                                    </button>
                                  ) : null}
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div
                      className="flex items-center cursor-pointer hover:text-primary"
                      onClick={() => onVacanciesClick(campaign)}
                    >
                      <Briefcase className="h-4 w-4 text-muted-foreground mr-2" />
                      <span className="text-sm text-foreground">
                        {campaign.vacancies_count}&nbsp;vacancies
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex -space-x-2">
                      {(campaign.users || []).slice(0, 3).map((user) => (
                        <div
                          key={user.id}
                          className="w-8 h-8 rounded-full bg-muted-foreground flex items-center justify-center text-white text-sm ring-2 ring-white relative group"
                          title={user.name}
                        >
                          {user.name.charAt(0)}
                          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-background bg-foreground border border-border rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                            {user.name}
                          </div>
                        </div>
                      ))}
                      {campaign.users?.length > 3 && (
                        <div className="w-8 h-8 rounded-full bg-muted-foreground flex items-center justify-center text-white text-sm ring-2 ring-white relative group">
                          +{campaign.users.length - 3}
                          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-background bg-foreground border border-border rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                            {campaign.users
                              .slice(3)
                              .map((user) => user.name)
                              .join(", ")}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-medium">
                    <div className="flex items-center justify-center space-x-3">
                      <button
                        onClick={() => handleEdit(campaign.id)}
                        className="text-muted-foreground hover:text-muted-foreground relative group"
                      >
                        <Edit className="h-5 w-5" />
                        <div className="absolute bottom-full right-0 mb-2 px-2 py-1 text-xs text-background bg-foreground border border-border rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                          Edit Campaign
                        </div>
                      </button>
                      {campaign.status != 2 && (
                        <div className="relative">
                          <div className="relative inline-block text-left">
                            <button
                              className={`text-muted-foreground hover:text-muted-foreground rounded-full p-1 hover:bg-muted focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
                                activeMenu == campaign.id ? "bg-muted" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveMenu(
                                  activeMenu == campaign.id
                                    ? null
                                    : campaign.id,
                                );
                              }}
                            >
                              <MoreVertical className="h-5 w-5" />
                            </button>
                            {activeMenu == campaign.id && (
                              <>
                                <div
                                  className="fixed inset-0 z-[99]"
                                  onClick={() => setActiveMenu(null)}
                                ></div>
                                <div
                                  className={`${activeMenu == campaign.id ? "" : "hidden"} absolute transform translate-x-[-90%] mt-2 w-56 origin-top-right bg-card rounded-lg shadow-lg ring-1 ring-border z-[100] divide-y divide-border`}
                                  onClick={() => setActiveMenu(null)}
                                >
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(
                                        `/campaigns/${campaign.id}/vacancies/add`,
                                        {
                                          state: {
                                            companyId: campaign.company_id,
                                            campaign,
                                          },
                                        },
                                      );
                                      setActiveMenu(null);
                                    }}
                                    className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                  >
                                    {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                    {/* <Users className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                    Add vacancy
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      window.open(
                                        `/${campaign.company.slug}/${campaign.slug}`,
                                        "_blank",
                                      );
                                      setActiveMenu(null);
                                    }}
                                    className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                  >
                                    {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                    {/* <Eye className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                    View Microsite
                                  </button>
                                  {campaign.status == 1 && (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(campaign.id, 0);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                                    >
                                      {/* <span className="h-4 w-4 mr-3 text-muted-foreground"></span> */}
                                      {/* <FileText className="h-4 w-4 mr-3 text-muted-foreground" /> */}
                                      Mark as Draft
                                    </button>
                                  )}
                                  {[0, 1].includes(
                                    parseInt(campaign.status),
                                  ) ? (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleStatusChange(campaign.id, 2);
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150"
                                    >
                                      {/* <XCircle className="h-4 w-4 mr-3 text-red-500" /> */}
                                      Archive
                                    </button>
                                  ) : null}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex justify-center items-center h-24">
          <p className="text-muted-foreground text-lg">{noCampaignMessage}</p>
        </div>
      )}

      {/* Pagination Controls */}
      {serverPagination && (
        <Pagination
          currentPage={serverPagination?.current_page}
          totalPages={serverPagination?.last_page}
          per_page={serverPagination?.per_page}
          onPerPageChange={onPerPageChange}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};

export default CampaignTable;
